import { render, staticRenderFns } from "./Switchplan.vue?vue&type=template&id=510bd0e8&"
import script from "./Switchplan.vue?vue&type=script&lang=js&"
export * from "./Switchplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports